import { loadScript, container } from '@mtfe/sweet-utils';
import { addCustomError } from '@mtfe/sweet-report';


const HREF = window.location.href;
const { isInWeixin, isInTuanApp, isInWaiMaiApp, isIos, isAndroid } = container;

//参考：https://km.sankuai.com/page/210217357#id-%E4%BD%BF%E7%94%A8%E6%96%B9%E5%BC%8F
const config = {
    // --------------------必填项----------------------------
    risk_platform: (isInTuanApp || isInWaiMaiApp) ? (isIos ? 5 : 4) : (isInWeixin ? 11 : 3),
    risk_partner: 346,
    risk_app: 216, // h5传216
    redirectUri: HREF,
    // --------------------选填项----------------------------
    env: HREF.includes('waimai.test.sankuai.com') ? 'test' : (HREF.includes('waimai.st.sankuai.com') ? 'staging' : ''),// 空字符串 (线上环境，线上token）
    tokenVersion: 1,// 有效值1和2。1表示会生成两个token，key值分别为'token'和'mt_c_token'，值是一样的；2表示token的key值为'mt_c_token'。
    // phone_num: '', //预填充手机号码
    componentId: '', //组件最外层id（传入）   

    // ui配置项
    uiConfig: {
        extraClass: '',// 最外层wrapper的class, 覆盖默认样式使用
        loginBtnText: '登录', // 登录按钮文案
        codePlaceholder: '请输入短信验证码', //验证码placeholder
        phoneNumPlaceholder: '请输入手机号', // 手机号placeholder
        sendCodeText: '发送验证码', // 发送验证码按钮文案
        showSendCodeLoading: true, // 点击发送验证码时，是否展示小loading框
        sendCodeLoadingText: '发送中', // 出现倒计时之前的文案，showSendCodeLoading为true时生效
        sendCodeTextAgain: '重新发送',// 倒计时过后，重新发送验证码文案
        sendingCodeText: 's',// 倒计时中, '60'秒数后面的跟着的文字，默认's'
        sendCodePos: 2, // 发送验证码位置，有效值1和2，1表示上面，2表示下面。 如果配置了countrycode且可以选择其他国家，建议该值设置为2，否则这一行很挤，样式难处理
        showCancel: false, // 是否显示取消按钮，一般用来配合弹窗使用，需要自己改写样式
        cancelBtnText: '取消', // 取消按钮文案，仅当 uiConfig.showCancel === true 时生效
        tipStyle: 1, // 提示展示方式，有效值1和2，1表示弹toast 2表示在input下方展示，默认值1
        showClearInput: false, // 是否展示清空input的按钮
        phonenumberFormat: false, // 是否格式化国内手机号3-4-4
        loginMode: 1, // 默认为1，展示登录按钮，用户需点击登录按钮登录；2不展示登录按钮，用户输入6位验证码后自动登录
        phoneNumErrorText: '', // 手机号错误提示文案，不填默认展示后端返回内容
        codeErrorText: '', // 验证码错误提示文案，不填默认展示后端返回内容
        loginErrorText: '', // 登录错误提示文案，不填默认展示后端返回内容
        errorPos: 1, // 错误信息展示位置，1表示手机号错误展示在手机号input下面，验证码及登录错误展示在验证码input下；2表示错误均展示在手机号input下；3表示错误均展示在验证码input下，默认值为1
        accountTip: '', //提示语内容，默认为未注册的手机号验证后自动创建美团账户
        footerContent: "我已阅读并同意<a href='https://rules-center.meituan.com/m/detail/4' style='color: #2440b3;text-decoration:none;'>《美团用户协议》</a>、<a href='https://rules-center.meituan.com/m/detail/2' style='color: #2440b3;text-decoration:none;'>《隐私政策》</a>，并授权美团使用该美团账号信息（如昵称、头像、收货地址）进行统一管理"
    },
    sameSite: false
}

const loadLogin = (loginContainerId = 'loignContainer', extraClass = '', cb) => {
    config.componentId = loginContainerId;
    config.uiConfig.extraClass = extraClass;
    // 原地址
    // https://s0.meituan.net/bs/mt-login-component/v3.0/index.min.js
    loadScript('https://passport.meituan.com/mt-login-component/v4.0/index.min.js', {}, (err, script) => {
        if (err) {
            addCustomError('mt-login-component sdk 加载异常')
            return;
        }

        window.iLoginComp.session.on('loginComplete', (info) => {
            if (cb.loginCompleteHandler) {
                cb.loginCompleteHandler(info);
            }
        });

        window.iLoginComp.init(config);
    });
};

export default loadLogin;
